import React, { useState, useEffect } from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import PageContainer from '../../common/components/Page/PageContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import ReportRendererContainer from '../../common/components/ReportRenderer/ReportRendererContainer';
import { connect } from 'react-redux';
import moment from 'moment';
import { getInstrumentsList } from './ManufacturingDashboard.actions';
import Loading from '../../common/components/Loading/Loading';
import Tile from '../../common/components/Tile/Tile';

const defaultDate = {
  startDate: moment.utc().startOf('day').subtract(3, 'months').format(),
  endDate: moment.utc().startOf('date').add(1, 'day').format(),
};

const ManufacturingDashboard = (props) => {
  const [instrumentList, setInstrumentList] = useState(null);

  useEffect(() => {
    getInstrumentsList().then((res) => {
      let result = res.body;
      if (!result.Data) {
        setInstrumentList('NoData');
      } else {
        let instrumentsToShow = result.Data.filter((el) => el.AtManufacturer == true)
          .map((a) => a.SerialNumber)
          .join(';');

        if (!instrumentsToShow) {
          setInstrumentList('NoData');
        } else {
          setInstrumentList(instrumentsToShow);
        }
      }
    });
  }, []);

  return (
    <PageContainer pageName="manfucaturing-dashboard">
      <PermissionsCheck
        appliedToPage={true}
        permission={PermissionsEnum.VIEW_MANUFACTURING_DASHBOARD}
      >
        {instrumentList != 'NoData' ? (
          <Loading condition={instrumentList == null}>
            <div>{loadReport(instrumentList)}</div>
          </Loading>
        ) : (
          <Tile title={'Device list'}>
            <div>No data to show</div>
          </Tile>
        )}
      </PermissionsCheck>
    </PageContainer>
  );
};

function loadReport(instrumentList) {
  var query = {
    SelectedInstrument: instrumentList,
    ReportName: 'manufacturingDashboard',
    StartDate: defaultDate.startDate,
    EndDate: defaultDate.endDate,
  };

  return <ReportRendererContainer query={query} onCellClick={onCellClick} useCache={true} />;
}

function onCellClick(params, updateRouterHistory) {
  const serialNumber = params.row.RowKey;
  const reportName = params.col.reportName;
  const startDate = defaultDate.startDate;
  const endDate = defaultDate.endDate;
  if (reportName) {
    updateRouterHistory(
      `/manufacturingDashboard-details/${serialNumber}/?ReportName=${reportName}&SelectedInstrument=${serialNumber}&StartDate=${startDate}&EndDate=${endDate}`
    );
  }
}

function mapStateToProps(state) {
  return { globalDateTime: state.globalDateTime };
}

export default withRouter(connect(mapStateToProps)(ManufacturingDashboard));
